import React from "react";
import { useTranslation } from "react-i18next";

interface ProjectSummaryProps {
  totalBricks: number;
  totalLayers: number;
  gridSize: { width: number; height: number };
  optimizationEnabled: boolean;
}

const ProjectSummary: React.FC<ProjectSummaryProps> = ({
  totalBricks,
  totalLayers,
  gridSize,
  optimizationEnabled,
}) => {
  const { t } = useTranslation();
  return (
    <div className="summary">
      <h3>{t("instructions.projectSummary")}</h3>
      <div className="stats">
        <div className="stat-item">
          <label>{t("instructions.totalBricks")}:</label>
          <span>{totalBricks}</span>
        </div>
        <div className="stat-item">
          <label>{t("instructions.totalLayers")}:</label>
          <span>{totalLayers}</span>
        </div>
        <div className="stat-item">
          <label>{t("instructions.gridSize")}:</label>
          <span>
            {gridSize.width} x {gridSize.height}
          </span>
        </div>
        {optimizationEnabled && (
          <div className="stat-item highlight">
            <label>{t("instructions.optimization")}:</label>
            <span>{t("instructions.smartModeActive")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectSummary;
